module.exports = __webpack_public_path__ + "static/media/pci-logo.da541ce3.png";